// extracted by mini-css-extract-plugin
export default {"wrap":"About_wrap__9r82b","img":"About_img__kXhi1","disc":"About_disc__8S5MA","title":"About_title__okoM5","line":"About_line__Hl1nw","text":"About_text__Baoxt"};